import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const ContentWrapper = styled.div(
    () => css`
        width: 100%;
    `
);
